import React, { useState } from "react";
import { Link } from "react-router-dom";
import leftBg from "../../img/modinet_login_bg.jpg";
import { WebSocketMessage } from "../../serverConnection";
import TextFieldGroup from "../common/TextFieldGroup";
var Login = function (props) {
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(""), password = _b[0], setPassword = _b[1];
    var onSubmit = function (e) {
        e.preventDefault();
        var userData = {
            email: email,
            password: password
        };
        props.send(WebSocketMessage("login", "update", userData));
    };
    return React.createElement("div", null,
        React.createElement("img", { src: leftBg, className: "login__bg", alt: "" }),
        React.createElement("form", { className: "auth-form", onSubmit: onSubmit },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col s12" },
                    React.createElement("div", { className: "card" },
                        React.createElement("div", { className: "card-content" },
                            React.createElement(TextFieldGroup, { name: "email", type: "email", label: "Email Adress", value: email, onChange: function (e) { return setEmail(e.target.value); } }),
                            React.createElement(TextFieldGroup, { name: "password", type: "password", label: "Password", value: password, onChange: function (e) { return setPassword(e.target.value); } }),
                            React.createElement("button", { className: "btn waves-effect waves-light black col s12", type: "submit" }, "Login"),
                            React.createElement("br", null),
                            React.createElement("br", null)),
                        React.createElement("div", { className: "card-action" },
                            React.createElement(Link, { to: "/forgot" }, "Forgot password ?")))))),
        React.createElement("div", { className: "headline-div" },
            React.createElement("h2", { className: " headline-footer right right-align white-text" },
                "MODERN",
                React.createElement("br", null),
                "DIGITAL ",
                React.createElement("br", null),
                "NETWORK")));
};
export default Login;



//////////////////
// WEBPACK FOOTER
// ./src/components/auth/Login.tsx
// module id = 1284
// module chunks = 0